<template>
  <div>
    <transactions
      :transaction-class="transactionClass"
      verbose-name="Avoir"
      verbose-name-plural="Avoirs"
      ressource="credits"
      :add="false"
      :colors="colors"
    ></transactions>
  </div>
</template>

<script>
import { Hk } from '@/node-sdk'

import Transactions from '@/router/view/commercial/components/transactions'

const { Credit } = Hk.Crm
export default {
  name: 'credits',

  components: {
    Transactions,
  },

  data() {
    return {
      transactionClass: null,
      colors: {
        pending: 'warning',
        accepted: 'success',
        canceled: 'danger',
      },
    }
  },

  mounted() {
    this.transactionClass = Credit
  },
}
</script>

<style></style>
